import { initTranslations } from '@app/translations';
import initializeSentry from '@app/utils/initializeSentry';
import initRoutingUtil from '@app/utils/Routing';
import { mount } from './mount';
initializeSentry();
initTranslations();
const renderApp = () => {
    const container = document.getElementById('root');
    initRoutingUtil();
    if (container) {
        mount(container, { isStandalone: true });
    }
};
renderApp();
